import { co2 } from './common';

export default {
  'consumption.co2': `${co2} émissions combinées`,
  'consumption.energy': "Consommation d'énergie",
  'consumption.fuel': 'Consommation de carburant combinée',
  'footnotes.local': '',
  'footnotes.wltp': `La consommation normalisée de carburant/d'électricité est calculée selon la méthode de mesure 715/2007/CEE dans sa version actuellement en vigueur. Les valeurs indiquées relatives à la consommation d?énergie et aux émissions de ${co2} sont des valeurs suisses et se basent sur la réception par type. Il s'agit ici de valeurs qui ont été déterminées dans le cycle de mesure WLTP. Dans la pratique, les valeurs de consommation peuvent cependant diverger des valeurs indiquées, en fonction du style de conduite ainsi que des conditions de la chaussée, du trafic, des influences de l?environnement et de l?état du véhicule. Les données ne se réfèrent pas à un véhicule précis et ne font pas partie de l'offre, mais servent uniquement à la comparaison entre les différents types de véhicules. Afin que les consommations d?énergie des différentes motorisations (essence, diesel, gaz, électricité, etc.) soient comparables, elles sont indiquées en sus sous la forme d'équivalents essence (unité de mesure pour l'énergie). Le ${co2} est le principal gaz à effet de serre responsable du réchauffement climatique; les émissions moyennes de ${co2} de tous les types de véhicules offerts (quelle que soit la marque) s'élèvent à 169 g/km pour l'année 2021.`,
  'footnotes.nedc': '',
  'footnotes.emissions.appendix': `Weitere Informationen über den offiziellen Kraftstoffverbrauch und die ${co2}-Emissionen neuer Personenkraftwagen erhalten Sie bei Ihrem Mercedes-Benz Vertragshändler.`,
  'search.input.label': 'Votre terme de recherche / Configurateur OnlineCode',
  'search.result.buy-online': 'Acheter en Ligne',
  'search.results':
    'Aucun résultat de recherche trouvé | {count} Résultat de la recherche | {count}  Résultats de la recherche',
  'search.results.count': '{count}  Résultats de la recherche',
  'search.results.backup': "Aucune correspondance exacte n'a été trouvée. Voir les pages connexes:",
  'search.results.none.summary':
    "Il n'y a pas de résultats de recherche pour ce terme. Veuillez essayer à nouveau avec un autre terme de recherche.",
  'search.show-more': 'En savoir plus',
  'search.unavailable': "La recherche n'est pas disponible actuellement.",
  'search.result.new': 'Nouveau',

  'input.placeholder': 'Votre terme de recherche / Configurateur OnlineCode',

  'search.result.consumption': 'Consommation',
  'watch.video': 'Regarder la vidéo',
  'input.recently': 'Récemment recherché',
  'input.help.title': 'Que devriez-vous recherchez?',
  'input.help.text':
    "Rechercher par types de véhicules, modèles, codes de configuration ou rechercher des accessoires, d'autres produits et informations",

  all: 'Tous',
  UCOS: "Boutique en ligne véhicules d'occasion",
  PASSENGER_CARS: 'VP',
  VANS: 'Vans',
  NCOS: 'Boutique en ligne véhicules neufs',
  VIDEO: 'Vidéos',
  DEALER_LOCATOR: 'Recherche de distributeur',
  CONFIGURATOR: 'Configurer le véhicule',
  TEST_DRIVE: 'Essai sur route',
  VEHICLE_SEARCH: 'Recherche de véhicules d’occasion',
  COLLECT: 'Collection et accessoires',
  CONNECT: 'Mercedes me Store',
  ACCESSORIES: 'Accessoires de voiture',

  'search.result.grid': 'Grille',
  'search.result.list': 'Liste',

  // No results
  'support.check': "Veuillez vérifier les fautes d'orthographe ou réessayer avec une autre phrase",
  'support.no.results': "Aucun résultat de recherche n'est disponible pour ce terme de recherche.",
  'support.no.results.term': 'Aucun résultat',
  'support.chat': 'Vous ne trouvez pas ce que vous cherchez? Veuillez utiliser notre ',
  'support.chat.with.us': 'support de chat en ligne.',

  'search.results.offer': 'Offres populaires pour "{query}":',
};
